import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute , Router} from '@angular/router';
import { Response } from '@angular/http';

import { EventManager, AlertService, JhiLanguageService } from 'ng-jhipster';
import { DateConverterService } from '../shared/date/date-converter.service';
import { LoanOdAccounts } from './loan-od-accounts.model';
import { LoanOdAccountsService } from './loan-od-accounts.service';
import { ReverseCompositeDto } from './reverse-composite-dto';

@Component({
    selector: 'jhi-loan-od-accounts-amend-normal-interest',
    templateUrl: './loan-od-accounts-amend-normal-interest.component.html',
})
export class LoanOdAccountsAmendNormalInterestComponent implements OnInit {

    loanOdAccounts: LoanOdAccounts;
    subscription: any;
    proceedIsTrue: boolean;
    transactionTypeList: any[];
    dataIsAvailable: boolean;
    isSuccessful: boolean;
    reverseCompositeDto: ReverseCompositeDto;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private alertService: AlertService,
        private router: Router,
        private loanODAccountsService: LoanOdAccountsService,
        private eventManager: EventManager,
        private route: ActivatedRoute,
        private dateConverter: DateConverterService
    ) {
        // this.jhiLanguageService.setLocations(['loanOdAccounts']);
        this.proceedIsTrue = false;
        this.dataIsAvailable = false;
        this.isSuccessful = false;
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe((params) => {
            this.load(params['accountId']);
        });
    }

    load(accountId) {
        this.loanODAccountsService.amendNormalInterestEntry(accountId).subscribe((loanOdAccounts) => {
            this.loanOdAccounts = loanOdAccounts;
            this.loanOdAccounts.openedOnDate = this.dateConverter
                .fromServerToNgbDatePicker(this.loanOdAccounts.openedOnDate);
            if (this.loanOdAccounts.normalInterestRate === undefined || this.loanOdAccounts.normalInterestRate === null) {
                this.loanOdAccounts.normalInterestRate = {
                    // tslint:disable-next-line:no-construct
                    magnitude: new Number(),
                }
            }
        },
        (res) => {
            this.onError(res);
            this.router.navigate(['/loans/loan-od-accounts']);
        });
    }

    clear() {
        this.loanOdAccounts = new LoanOdAccounts();
        this.router.navigate(['/loans/loan-od-accounts']);
    }

    print() {
        window.print();
    }

    private onError(error) {
        try {
            const errorString = error.json().localizedMessage;
            if (errorString) {
                this.alertService.error('encoreclientApp.loanOdAccounts.serverError', { message: errorString });
            } else {
            this.alertService.error('encoreclientApp.loanOdAccounts.genericError');
            }
        } catch (exception) {
            try {
                const errorString = error.text();
                if (errorString) {
                    this.alertService.error('encoreclientApp.loanOdAccounts.serverError', { message: errorString });
                } else {
                    this.alertService.error('encoreclientApp.loanOdAccounts.genericError');
                }
            } catch (exception) {
                this.alertService.error('encoreclientApp.loanOdAccounts.genericError');
            }
        }
    }

    execute() {
        this.loanODAccountsService.amendNormalInterestExecute(this.loanOdAccounts)
            .subscribe(
                (res) => this.onExecuteSuccess(res),
                (res) => this.onError(res)
            );
    }

    private onExecuteSuccess(data) {
        this.reverseCompositeDto = data;
        this.loanOdAccounts.openedOnDate = this.dateConverter
            .fromNgbDatePickerToDateObject(this.loanOdAccounts.openedOnDate);
        this.proceedIsTrue = true;
    }

    confirm() {
        this.loanODAccountsService.amendNormalInterestResult(this.loanOdAccounts)
            .subscribe(
                (res) => this.onConfirmSuccess(res),
                (res) => {
                    this.onError(res);
                    this.back();
                }
            );
    }

    private onConfirmSuccess(data) {
        this.isSuccessful = true;
        this.alertService.success('encoreclientApp.loanOdAccounts.amendNormalInterestSuccess');
        this.router.navigate(['/loans/loan-od-accounts']);
    }
    back() {
        this.loanOdAccounts.openedOnDate = this.dateConverter
            .fromDateObjectToNgbDatePicker(this.loanOdAccounts.openedOnDate);
        this.proceedIsTrue = !this.proceedIsTrue;
    }

}
